import { Injectable } from '@angular/core';
import {Http, Headers} from '@angular/http';

import {Observable} from 'rxjs/Observable'
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class AdddataService {
  authToken:any;
  headers= new Headers();
  
  constructor(private http:Http, private authService:AuthenticationService) {
    this.authService.RetrieveloadToken();
    this.headers.append('Authorization', this.authService.RetrieveloadToken());
   }

  
  addEvent(formdata:any){
     let _url:string = "/additems/add_event";
     return this.http.post(_url,formdata,{headers:this.headers})
     .catch(this._errorHandler);
   }

   addWorkGroup(formdata:any){
      let _url:string = "/additems/add_workgroup";
      return this.http.post(_url,formdata,{headers:this.headers})
      .catch(this._errorHandler);
    }

    addAccount(formdata:any){
      let _url:string = "/additems/add_account";
      return this.http.post(_url,formdata,{headers:this.headers})
      .catch(this._errorHandler);
    }


   addRoomsInsideUsers(rooms_group:any,accountID:any){
      let _url:string = "/users/add_rooms_to_users"+accountID;
      return this.http.post(_url,rooms_group,{headers:this.headers})
      .catch(this._errorHandler);
    }

   addRoom(formdata:any){
      let _url:string = "/additems/add_room";
      return this.http.post(_url,formdata,{headers:this.headers})
      .catch(this._errorHandler);
    }

    addOutlookRoom(formdata:any){
      let _url:string = "/additems/add_outlook_room";
      return this.http.post(_url,formdata,{headers:this.headers})
      .catch(this._errorHandler);
    }


   _errorHandler(error: Response){
     console.error('Error occured: ' +error);
     return Observable.throw(error||'some error on server occured');
   }
}



// WEBPACK FOOTER //
// ./src/app/services/adddata.service.ts